// Pagination.tsx
import React from "react";
import classes from "./Pagination.module.scss";
import { Table } from "@tanstack/react-table";

type PaginationProps<TData> = {
  table: Table<TData>;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  pageIndex: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
};

const Pagination = <TData,>({
  table,
  pageSize,
  setPageSize,
  pageIndex,
  setPageIndex,
}: PaginationProps<TData>) => {
  const pageCount = table.getPageCount();

  const handlePageChange = (newPage: number) => {
    const validPage = Math.max(0, Math.min(newPage, pageCount - 1));
    table.setPageIndex(validPage);
    setPageIndex(validPage);
  };

  return (
    <div className={classes.pagination}>
      <div className={classes.pageButtons}>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(0)}
          disabled={!table.getCanPreviousPage()}
        >
          {"<<"}
        </button>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(pageIndex - 1)}
          disabled={!table.getCanPreviousPage()}
        >
          {"<"}
        </button>
        <span className={classes.pageInfo}>
          ページ{" "}
          <strong>
            {table.getState().pagination.pageIndex + 1} / {pageCount}
          </strong>
        </span>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(pageIndex + 1)}
          disabled={!table.getCanNextPage()}
        >
          {">"}
        </button>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(pageCount - 1)}
          disabled={!table.getCanNextPage()}
        >
          {">>"}
        </button>
      </div>

      {/* ページサイズの選択 */}
      <select
        value={pageSize}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          const newSize = Number(e.target.value);
          setPageSize(newSize);
          table.setPageSize(newSize);
        }}
      >
        {[15, 30, 50].map((size) => (
          <option key={size} value={size}>
            {size} 件表示
          </option>
        ))}
      </select>
    </div>
  );
};

export default Pagination;
